export const isExternalLink = (href = '') => /^(https?|mailto):/i.test(href)
